var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurriculumBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0086 6.8262C12.5282 7.53896 11.1301 8.22431 9.73198 8.86854C9.21111 9.11527 8.66283 9.32088 8.11455 9.48536C7.49774 9.66355 6.88092 9.51277 6.30523 9.25234C4.67409 8.48475 3.05666 7.70345 1.42553 6.93586C0.507159 6.49723 0 5.77076 0 4.78385C0 3.74212 0.561988 3.02936 1.49406 2.59073C3.15261 1.82314 4.78375 1.02813 6.4423 0.26054C7.27842 -0.123256 8.14196 -0.0684282 8.96439 0.329075C10.5955 1.09667 12.2267 1.87797 13.8441 2.65927C14.7487 3.09789 15.2148 3.85178 15.2285 4.85239C15.2422 7.2237 15.2422 9.60872 15.2285 11.98C15.2285 12.4461 14.9681 12.7476 14.598 12.7476C14.2279 12.7476 13.9949 12.4598 13.9812 11.9663C13.9812 10.4311 13.9812 8.88225 13.9812 7.34707C14.0086 7.19629 14.0086 7.05922 14.0086 6.8262Z",
    fill: "#2396F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.53434 8.91211C3.57608 9.40556 4.56298 9.8716 5.53618 10.3376C6.93429 11.0093 8.3187 11.023 9.71682 10.3239C10.69 9.85789 11.6632 9.40556 12.6912 8.92582C12.6775 10.1046 12.8557 11.256 12.1978 12.284C11.581 13.2572 10.6489 13.6547 9.59345 13.8466C8.01715 14.1208 6.44084 14.1071 4.89195 13.6684C3.52125 13.2846 2.61658 12.147 2.54805 10.7214C2.50693 10.1457 2.53434 9.57005 2.53434 8.91211Z",
    fill: "#2396F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurriculumBlue);
export default __webpack_public_path__ + "static/media/curriculumBlue.c11f15242d3d4d81dbf74359eddd8e86.svg";
export { ForwardRef as ReactComponent };